
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CxPasswordNote',
  computed: {
    translations(): {
      twelveCharacters: string;
      threeOutOfFourCategories: string;
      lowercase: string;
      uppercase: string;
      specialCharacters: string;
      numbers: string;
      avoidRepeatingCharacters: string;
      avoidConsecutiveKeyboardPatterns: string;
      } {
      return {
        twelveCharacters: this.$gettext('12 characters'),
        threeOutOfFourCategories: this.$gettext('3 out of 4 categories:'),
        lowercase: this.$gettext('lowercase'),
        uppercase: this.$gettext('uppercase'),
        specialCharacters: this.$gettext('special characters'),
        numbers: this.$gettext('numbers'),
        avoidRepeatingCharacters: this.$gettext('avoid repeating characters e.g. "aaa"'),
        avoidConsecutiveKeyboardPatterns: this.$gettext('avoid consecutive keyboard patterns e.g. "asdf"')
      };
    }
  }
});
